import React, { useEffect, useRef, useState } from "react";
import { FaCartPlus } from "react-icons/fa";
import { motion } from "framer-motion";
import NotFound from "../img/NotFound.svg";
import { useStateValue } from "../context/StateProvider";
import { actionType } from "../context/reducer";

const GalleryContainer = ({ flag, data, scrollValue }) => {
  const galleryContainer = useRef();
  //console.log(data);
  //const [items, setItems] = useState([]);

  useEffect(() => {
    galleryContainer.current.scrollLeft += scrollValue;
  }, [scrollValue]);

//   useEffect(() => {
//   }, [items]);

  return (
    <div
      ref={galleryContainer}
      className={`w-full flex items-center gap-3  my-12 scroll-smooth  ${
        flag
          ? "overflow-x-scroll scrollbar-none"
          : "overflow-x-hidden flex-wrap justify-center"
      }`}
    >
      {data && data.length > 0 ? (
        data.map((item) => (
          <div
            key={item?.id}
            className="w-475 h-[375px] min-w-[275px] md:w-300 md:min-w-[400px]  bg-cardOverlay rounded-lg shadow-lg hover:drop-shadow-lg flex flex-col items-center justify-evenly relative"
          >  
           {/* <img className="w-full" src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSqDrMH_obcujlyysTd3cBVx7YjQoLh4B0cXg&usqp=CAU" alt="Sunset in the mountains"></img>           */}
           <div className="px-6 py-4"> 
              <div className="font-bold text-xl">{item?.title}</div>
              {/* <p className="text-gray-700 text-base">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptatibus quia, nulla! Maiores et perferendis eaque, exercitationem praesentium nihil.
              </p> */}
            </div>
            <div className="w-full flex items-center justify-between">
              <motion.div
                className="w-full h-40 drop-shadow-2xl"
                whileHover={{ scale: 1.2 }}
              >
                <img
                  src={item?.imageURL}
                  alt=""
                  className="w-full h-full object-cover"
                />
              </motion.div>
 
            </div>

            <div className="px-6 py-4">
                <p className="text-gray-700 text-base">
                {item?.description}
                </p>
            </div>

            <div className="w-full flex flex-col items-end justify-end -mt-8">
              {/* <p className="font-bold text-xl mb-2 md:text-lg z-50">
                {item?.title}
              </p> */}
              {/* <p className="mt-1 text-sm text-gray-500">
                {item?.calories} Calories
              </p> */}
              <div className="flex items-center pt-8 pr-8 gap-8">
                <p className="text-lg text-headingColor font-semibold">
                  {item?.eventDate}
                </p>
              </div>
            </div>
          </div>
        ))
      ) : (
        <div className="w-full flex flex-col items-center justify-center">
          <img src={NotFound} className="h-340" alt="No Disponible"/>
          <p className="text-xl text-headingColor font-semibold my-2">
              Items no disponibles
          </p>
        </div>
      )}
    </div>
  );
};

export default GalleryContainer;